export const CYLINDERS = [
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '10', label: '10' },
  { value: '12', label: '12' },
  { value: 'Rotary Engine, No Cylinder', label: 'Rotary Engine, No Cylinder' },
  {
    value: 'Electric Motor, No Cylinder',
    label: 'Electric Motor, No Cylinder',
  },
  {
    value: 'Electric Motor, No Cylinder - LSV',
    label: 'Electric Motor, No Cylinder - Low Speed Vehicle (LSV)',
  },
  {
    value: 'Electric Motor, 4 Cylinder Extended',
    label: 'Electric Motor, 4 Cylinder Engine for Extended Range',
  },
  { value: 'Unknown', label: 'Unknown Number of Cylinders' },
];

const currentYear = new Date().getFullYear();
export const VEHICLE_YEARS = Array.from(
  { length: currentYear + 1 - 2002 + 1 },
  (_, i) => {
    const year = currentYear + 1 - i;
    return { value: year, label: String(year) };
  },
);

export const OPCF_20_LIMIT_PER_DAY_CAD = [
  { value: 300, label: '$300' },
  { value: 450, label: '$450' },
  { value: 600, label: '$600' },
  { value: 750, label: '$750' },
  { value: 900, label: '$900' },
  { value: 1000, label: '$1,000' },
  { value: 1200, label: '$1,200' },
  { value: 1350, label: '$1,350' },
  { value: 1500, label: '$1,500' },
  { value: 1800, label: '$1,800' },
  { value: 2000, label: '$2,000' },
  { value: 2250, label: '$2,250' },
  { value: 2500, label: '$2,500' },
  { value: 2700, label: '$2,700' },
  { value: 3000, label: '$3,000' },
  { value: 3500, label: '$3,500' },
  { value: 4000, label: '$4,000' },
  { value: 5000, label: '$5,000' },
  { value: 7500, label: '$7,500' },
  { value: 10000, label: '$10,000' },
];

export const OPCF_27_LIMIT_CAD = [
  { value: 20000, label: '$20,000' },
  { value: 25000, label: '$25,000' },
  { value: 30000, label: '$30,000' },
  { value: 35000, label: '$35,000' },
  { value: 40000, label: '$40,000' },
  { value: 45000, label: '$45,000' },
  { value: 50000, label: '$50,000' },
  { value: 55000, label: '$55,000' },
  { value: 60000, label: '$60,000' },
  { value: 65000, label: '$65,000' },
  { value: 70000, label: '$70,000' },
  { value: 75000, label: '$75,000' },
  { value: 100000, label: '$100,000' },
  { value: 150000, label: '$150,000' },
];

export const OPCF_43_INDEMNITY_PERIOD_MONTHS = [
  { value: 12, label: '12 months' },
  { value: 18, label: '18 months' },
  { value: 24, label: '24 months' },
  { value: 30, label: '30 months' },
  { value: 36, label: '36 months' },
  { value: 42, label: '42 months' },
  { value: 48, label: '48 months' },
  { value: 54, label: '54 months' },
  { value: 60, label: '60 months' },
];

export const RIDE_SHARING_COMPANIES = [
  { value: 'uber', label: 'Uber' },
  { value: 'lyft', label: 'Lyft' },
  { value: 'doordash', label: 'DoorDash' },
  { value: 'skip', label: 'Skip The Dishes' },
  { value: 'instacart', label: 'Instacart' },
];

export const createEmptyVehicle = (id: number = 1) => ({
  id,
  registered_owners: [
    { first_name: '', last_name: '', business_name: '', is_business: false },
  ],
  vehicle_model_year: null as number | null,
  make: '',
  model: '',
  vin: '',
  vicc_code: '',
  vehicle_ref: '',
  manufacturer_ref: '',
  model_ref: '',
  fuel_type: '',
  vehicle_body_type: '',
  cylinders: '',
  vehicle_ownership: '',
  garaging: {
    same_as_applicant: false,
    postal_code: '',
    city: '',
    street_number: '',
    street_name: '',
    parking_at_night: '',
    latitude: null as number | null,
    longitude: null as number | null,
  },
  vehicle_use: '',
  distance: {
    one_way_km: null as number | null,
    annual_km: null as number | null,
    business_km: null as number | null,
  },
  value: {
    list_price_new: null as number | null,
    purchase_price: null as number | null,
  },
  purchase_info: {
    condition: '',
    purchase_date: null as string | null,
    km_at_purchase: null as number | null,
  },
  anti_theft: {
    device_types: [] as string[],
    device_type_other: '',
    manufacturers: [] as string[],
  },
  safety_features: [] as string[],
  safety_features_other: '',
  discounts: {
    single_vehicle_mvd: false,
    winter_tires: false,
  },
  principal_driver_id: null as number | null,
  secondary_drivers: [] as number[],
  occasional_drivers: [] as number[],
  telematics_enabled: false,
  coverages: {
    liability_limit_cad: '',
    dcpd_deductible_cad: '',
    collision_enabled: false,
    collision_deductible_cad: '',
    comprehensive_enabled: false,
    comprehensive_deductible_cad: '',
    all_perils_enabled: true,
    all_perils_deductible_cad: '',
    // Endorsements
    opcf_2_enabled: false,
    opcf_6a_passengers_enabled: false,
    opcf_8_enabled: false,
    opcf_8_limit_cad: null as number | null,
    opcf_8a_enabled: false,
    opcf_8a_limit_cad: null as number | null,
    opcf_8a_deductible_cad: null as number | null,
    sef_13c_enabled: false,
    sef_13d_enabled: false,
    sef_49a_enabled: false,
    cae_17_enabled: false,
    cae_18_enabled: false,
    sef_13h_enabled: false,
    opcf_4_min_enabled: false,
    opcf_19a_enabled: false,
    opcf_20_enabled: true,
    opcf_20_limit_per_day_cad: null as number | null,
    opcf_20_disappearing_deductible: false,
    opcf_27_enabled: true,
    opcf_27_limit_cad: null as number | null,
    opcf_35_enabled: false,
    opcf_43_enabled: false,
    opcf_43_indemnity_period_months: null as number | null,
    lienholder_endorsement_enabled: false,
    lessor_endorsement_enabled: false,
    opcf_44_enabled: true,
    opcf_48_enabled: false,
    opcf_49_enabled: false,
    waiver_of_deductible: false,
    accident_waiver: true,
    minor_conviction_protection: true,
    carsharing_enabled: false,
    ride_sharing_enabled: false,
    ride_sharing_companies: [] as string[],
    accident_benefits: {
      income_replacement_enabled: false,
      income_replacement_limit_per_week_cad: '',
      income_replacement_limit_per_week_cad_other: null as number | null,
      catastrophic_impairment_enabled: false,
      catastrophic_impairment_limit_cad: '',
      non_catastrophic_impairment_enabled: false,
      non_catastrophic_impairment_limit_cad: '',
      caregiver_enabled: false,
      caregiver_limit_cad: null as number | null,
      caregiver_coverage_options: [] as string[],
      housekeeping_home_maintenance_enabled: false,
      housekeeping_home_maintenance_limit_cad: null as number | null,
      housekeeping_home_maintenance_coverage_options: [] as string[],
      death_benefit_enabled: false,
      death_benefit_limit_cad: null as number | null,
      funeral_benefit_enabled: false,
      funeral_benefit_limit_cad: null as number | null,
      dependant_care_enabled: false,
      dependant_care_limit_cad: null as number | null,
      non_earner_enabled: false,
      non_earner_limit_cad: null as number | null,
      lost_educational_expenses_enabled: false,
      lost_educational_expenses_limit_cad: null as number | null,
      expenses_of_visitors_enabled: false,
      expenses_of_visitors_limit_cad: null as number | null,
      damage_to_personal_items_enabled: false,
      damage_to_personal_items_limit_cad: null as number | null,
      indexation_benefit_enabled: false,
    },
    accident_benefits_confirmed: false,
    all_coverages_confirmed: false,
  },
});
